/**
 * This tab's edit origin: a random id the planner sends with each save
 * (`edit_origin`), so the `trip_changed` event that save causes
 * (server/services/tripLiveUpdates.js) is skipped by the tab that made it.
 * Per page load, never stored; it identifies a tab, not a person.
 */
export const EDIT_ORIGIN = `tab_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
